module.exports = __webpack_public_path__ + "static/media/bin_icon.776e1c5a.svg";